import { render, staticRenderFns } from "./PlushieUpgradeAddForm.vue?vue&type=template&id=3260af0d&scoped=true&"
import script from "./PlushieUpgradeAddForm.vue?vue&type=script&lang=ts&"
export * from "./PlushieUpgradeAddForm.vue?vue&type=script&lang=ts&"
import style0 from "./PlushieUpgradeAddForm.vue?vue&type=style&index=0&id=3260af0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3260af0d",
  null
  
)

export default component.exports